// Exact RGB values and fabric swatch images sourced from Printify's color picker.
// Swatch images are stored locally in /assets/color-swatches/{id}.png
const s = (id) => `/assets/color-swatches/${id}.png`

export const COLOR_DATA = {
  White: { hex: '#FFFFFF', swatch: s('5853fec7ce46f30f8328200a') },
  'Sport Grey': { hex: '#CACACA', swatch: s('5853fecfce46f30f832820b5') },
  'Ice Grey': { hex: '#D7D6D3', swatch: s('5853fec7ce46f30f8328200a') },
  'Heather Military Green': { hex: '#828067', swatch: s('5853fecfce46f30f832820df') },
  'Graphite Heather': { hex: '#797C7E', swatch: null },
  'Dark Heather': { hex: '#454545', swatch: s('5853fed0ce46f30f8328211b') },
  'Heather Indigo': { hex: '#6A798E', swatch: s('5853fecfce46f30f832820ee') },
  'Dark Heather Grey': { hex: '#3A3D42', swatch: null },
  'Heather Navy': { hex: '#424753', swatch: s('5853fecfce46f30f832820f1') },
  Charcoal: { hex: '#585559', swatch: s('5853fecdce46f30f832820ac') },
  Black: { hex: '#000000', swatch: s('5853fecdce46f30f832820ac') },
  'Antique Cherry Red': { hex: '#A82235', swatch: s('5853fed0ce46f30f8328211e') },
  'Cherry Red': { hex: '#B41A29', swatch: s('5853fecdce46f30f832820ac') },
  'Heather Red': { hex: '#E3525F', swatch: s('5853fecfce46f30f832820dc') },
  Red: { hex: '#C62A32', swatch: s('5853fecdce46f30f832820ac') },
  'Dark Chocolate': { hex: '#31221D', swatch: s('5853fecdce46f30f832820ac') },
  'Heather Maroon': { hex: '#743A4C', swatch: null },
  Maroon: { hex: '#642838', swatch: s('5853fecdce46f30f832820ac') },
  'Cardinal Red': { hex: '#911A30', swatch: s('5853fecdce46f30f832820ac') },
  'Heather Cardinal': { hex: '#B54557', swatch: s('5853fed0ce46f30f8328212a') },
  Sand: { hex: '#DCD2BE', swatch: s('5853fec7ce46f30f8328200a') },
  Natural: { hex: '#FFF6E3', swatch: s('5853fec7ce46f30f8328200a') },
  Orange: { hex: '#EA5F22', swatch: s('5853fecdce46f30f832820ac') },
  Gold: { hex: '#FFB81C', swatch: s('5853fecdce46f30f832820ac') },
  Daisy: { hex: '#FED141', swatch: s('5853fec7ce46f30f8328200a') },
  Cornsilk: { hex: '#F7EF8F', swatch: s('5853fec7ce46f30f8328200a') },
  Pistachio: { hex: '#D3D590', swatch: s('5853fec7ce46f30f8328200a') },
  Kiwi: { hex: '#8FA749', swatch: s('5853fec7ce46f30f8328200a') },
  Lime: { hex: '#9EC46C', swatch: s('5853fec7ce46f30f8328200a') },
  'Mint Green': { hex: '#B1E0C0', swatch: s('5853fec7ce46f30f8328200a') },
  Sage: { hex: '#A4B09E', swatch: null },
  'Irish Green': { hex: '#279436', swatch: s('5853fecdce46f30f832820ac') },
  'Kelly Green': { hex: '#009660', swatch: s('5853fecdce46f30f832820ac') },
  'Military Green': { hex: '#62664C', swatch: s('5853fec7ce46f30f8328200a') },
  'Forest Green': { hex: '#223B26', swatch: s('5853fecdce46f30f832820ac') },
  'Heather Irish Green': { hex: '#6DEDA5', swatch: s('5853fecfce46f30f832820eb') },
  'Jade Dome': { hex: '#19998A', swatch: s('5853fecdce46f30f832820ac') },
  'Tropical Blue': { hex: '#0097A9', swatch: s('5853fecdce46f30f832820ac') },
  'Antique Sapphire': { hex: '#0082AE', swatch: s('5853fecfce46f30f832820d6') },
  Sapphire: { hex: '#0080B5', swatch: s('5853fecdce46f30f832820ac') },
  'Heather Sapphire': { hex: '#59A1CE', swatch: s('5853fecfce46f30f832820e8') },
  'Indigo Blue': { hex: '#476579', swatch: s('5853fecdce46f30f832820ac') },
  'Stone Blue': { hex: '#7F909C', swatch: s('5853fec7ce46f30f8328200a') },
  'Metro Blue': { hex: '#424A7E', swatch: s('5853fecdce46f30f832820ac') },
  Sky: { hex: '#8BCDEA', swatch: s('5853fec7ce46f30f8328200a') },
  'Light Blue': { hex: '#D6E6F7', swatch: s('5853fec7ce46f30f8328200a') },
  'Carolina Blue': { hex: '#7BA4DB', swatch: s('5853fec7ce46f30f8328200a') },
  'Heather Galapagos Blue': { hex: '#509AA0', swatch: null },
  Iris: { hex: '#6C84BB', swatch: s('5853fec7ce46f30f8328200a') },
  'Heather Royal': { hex: '#7C8CD9', swatch: s('5853fecfce46f30f832820e5') },
  Royal: { hex: '#084F97', swatch: s('5853fecdce46f30f832820ac') },
  Navy: { hex: '#1A2237', swatch: s('5853fecdce46f30f832820ac') },
  Paragon: { hex: '#948794', swatch: null },
  'Heather Radiant Orchid': { hex: '#D58EBB', swatch: null },
  'Heather Purple': { hex: '#6A4398', swatch: s('5853fecfce46f30f832820e2') },
  Purple: { hex: '#3C214E', swatch: s('5853fecdce46f30f832820ac') },
  'Light Pink': { hex: '#FEE0EB', swatch: s('5853fec7ce46f30f8328200a') },
  'Heather Berry': { hex: '#E775BF', swatch: null },
  'Antique Heliconia': { hex: '#B92972', swatch: s('5853fecfce46f30f832820be') },
  Azalea: { hex: '#EF8FBC', swatch: s('5853fec7ce46f30f8328200a') },
  Heliconia: { hex: '#DF5086', swatch: s('5853fec7ce46f30f8328200a') },
  'Heather Heliconia': { hex: '#FA74A6', swatch: null },
  'Heather Orange': { hex: '#FF8B4A', swatch: null },
  'Coral Silk': { hex: '#E67376', swatch: s('5853fec7ce46f30f8328200a') }
}

export const getHex = (name) => COLOR_DATA[name]?.hex || '#888888'
export const getSwatch = (name) => COLOR_DATA[name]?.swatch || null

export const isLight = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 > 160
}
